import instance from '@connection/instance';
import instanceBlob from '@connection/instanceBlob';

const setDefaultHeader = (data) => {
  const { token } = data;
  instance.defaults.headers.common['X-AUTH-TOKEN'] = token;
  instanceBlob.defaults.headers.common['X-AUTH-TOKEN'] = token;

  return data;
};

export default setDefaultHeader;
